import { resolveImageUrl } from "@/lib/api";

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2">
            <img
              src={resolveImageUrl("/uploads/logo.webp")}
              alt="우공이산 로고"
              className="h-10 w-auto"
            />
            <p className="mt-6 text-background-200/80 text-sm leading-relaxed max-w-md">
              오랜 시간이 걸려도 꾸준히 나아간다면 결국엔 뜻을 이룬다. 우공이
              산을 옮기는 마음으로 대한민국 산림 자원의 파쇄와 순환을 지켜온
              전문 회사입니다.
            </p>
          </div>

          <div>
            <h5 className="font-heading text-background-50 text-base font-semibold mb-4">
              바로가기
            </h5>
            <ul className="space-y-2.5 text-sm">
              {[
                { l: "회사 소개", h: "#about" },
                { l: "장비 정보", h: "#equipment" },
                { l: "서비스", h: "#services" },
                { l: "작업 이미지", h: "#gallery" },
                { l: "문의 게시판", h: "/inquiries" },
              ].map((n) => (
                <li key={n.h}>
                  <a
                    href={n.h}
                    className="text-background-200/80 hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {n.l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h5 className="font-heading text-background-50 text-base font-semibold mb-4">
              연락처
            </h5>
            <ul className="space-y-3 text-sm text-background-200/80">
              <li className="flex items-start gap-2.5">
                <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center mt-0.5 text-accent-400"></i>
                <span>경상남도 양산시 명동 990-9, 990-11</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-phone-line w-4 h-4 flex items-center justify-center mt-0.5 text-accent-400"></i>
                <span>010-8079-0428</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center mt-0.5 text-accent-400"></i>
                <span>manager@jigugnc.co.kr</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-time-line w-4 h-4 flex items-center justify-center mt-0.5 text-accent-400"></i>
                <span>평일 08:00 - 19:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="text-background-200/70 text-xs">
            © 2026 우공이산 (Ugongisan). All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}